import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { formatStringLowercaseWithDashes } from 'shared/utils/formatStringLowercaseWithDashes';
import { IProductTemplate } from 'shared/types/ProductTemplate';
import { AUCTION_PT_IMAGE_URLS } from 'productTemplate/enums/auctionPTImageUrls';

const getUrl = (productSlug: string) => {
  return `https://www.goat.com/sneakers/${formatStringLowercaseWithDashes(productSlug)}`;
};

export const getAuctionPTEventSchema = (productTemplate: IProductTemplate) => {
  const { auctionEndTime, auctionStartTime, name, slug, story } = productTemplate;

  const url = getUrl(slug);

  const shoeColor = name.toLowerCase().includes('green') ? 'green' : 'white';

  return JSON.stringify(
    omitBy(
      {
        '@context': 'http://schema.org',
        '@type': 'Event',
        name,
        startDate: auctionStartTime,
        endDate: auctionEndTime,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
        location: {
          '@type': 'VirtualLocation',
          url,
        },
        image: AUCTION_PT_IMAGE_URLS[shoeColor],
        description: story,
        organizer: {
          '@type': 'Organization',
          name: 'GOAT',
          url: 'https://www.goat.com/',
        },
      },
      isNil,
    ),
  );
};
